import { render } from "./Tiptap.vue?vue&type=template&id=094624de"
import script from "./Tiptap.vue?vue&type=script&lang=js"
export * from "./Tiptap.vue?vue&type=script&lang=js"

import "./Tiptap.vue?vue&type=style&index=0&id=094624de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__